<template>
    <div class="page">
        <div class="top">
            <div class="price">{{money_format(userAccount.amount/100, 2, '.', ',')}}</div>
            <div class="name">账户余额</div>
            <div class="iccid">ICCID：{{ recordLoginText }}</div>
        </div>
        <div class="title">充值金额</div>
        <div class="v-h5-price">
            <div class="v-item" v-for="(item,index) in packageChoose" :key="index" @click="change(item,index)" :class="{'package-item-action': currentItem === index}">
                <div class="item-price"><span>￥</span>{{item.amount}}</div>
                <div class="sj-price">到账{{item.amount * 1 + item.giftBalance * 1}}元</div>
                <div class="tj">{{item.title}}</div>
            </div>
        </div>
        <div class="btn" @click="btnActionRecharge()">充值</div>
        <div class="footer">
            <div class="title">限时活动 <span>｜为你优选</span></div>
            <img src="@/assets/she/22_1.png" alt="">
        </div>


        <!-- 密码框   -->
	    <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
	    <div class="van-popup van-popup--round van-popup--center changePasswordPanel-balanceRecharge" 
	        style="z-index: 2000; min-height: 25%; min-width: 80%;"
	        v-show="showPasswordPanel"
	        :style="{top:passwordPanelTop+'%'}"
	    >   

	    	<van-icon name="cross" class="icon-cross" @click="cancelChangePassword()"/>
	        
	        <!-- 密码输入框 -->
	        <p>设置支付密码：</p>
	        <van-password-input
	          :value="password"
	          :focused="passwordKeyboard"
	          @focus="passwordOnfocus()"
	        />

	        <!-- 再次确认密码输入框 -->
	        <p>再次确认密码：</p>
	        <van-password-input
	          :value="confirmPassword"
	          :focused="confirmPasswordKeyboard"
	          @focus="confirmPasswordOnfocus()"
	        />
	        <div class="confirmChangePassword">
	          <van-button class="confirmChangePasswordBtn" plain hairline  type="info" @click="sureToRecharge()">确 定</van-button>
	        </div>
	        
	    </div>

	    <!-- 数字键盘 -->
	    <van-number-keyboard
	      :z-index="2015"
	      :show="passwordKeyboard"

	      @input="passwordOnInput"
	      @delete="passwordOnDelete"
	      @blur="passwordKeyboard = false"
	    />

	    <van-number-keyboard
	      :z-index="2015"
	      :show="confirmPasswordKeyboard"

	      @input="confirmPasswordOnInput"
	      @delete="confirmPasswordOnDelete"
	      @blur="confirmPasswordKeyboard = false"
	    />
	    <!-- 数字键盘 end -->
	    <!-- 密码框 end  -->
        <Checkstand 
            :checkstandStyle="checkstandStyle"
            :dataToPay="dataToPay"
            :price="price" 
			:typeStyle="typeStyle"
        />
    </div>
</template>
<script>
import {wxRequest} from '@/api/user.js'
import { Toast } from 'vant';
import Checkstand from "@/components/Checkstand";
export default{
    data(){
        return{
            recordLoginText: localStorage.getItem('recordLoginText'),
            iccid:localStorage.getItem('iccid'),
             //当前余额套餐
		    currentItem: 0,
		    price: 0,
		    giftBalance: 0,
            userAccount:{},
		    alreadySetUp: false,
            packageChoose:[],
            checkstandStyle: {
                height: '50%',
                transition: '0.8s !important',
            },
            dataToPay:{},
            typeStyle:0,


             //设置密码
            type:'',
            showPasswordPanel: false,
		    password:'',
		    confirmPassword: "",
	      	passwordKeyboard : false,
	      	confirmPasswordKeyboard : false,
	      	passwordPanelTop: 50,
		    alreadySetUp: false,
        }
    },
    components:{
        Checkstand
    },
    created(){
    	wxRequest("sim/uniorder/param", {iccid:this.iccid}, "post").then(res => {
            if(res.data.code == 200 ){
            	this.packageChoose = res.data.data
                this.price = res.data.data[0].amount
                this.giftBalance = res.data.data[0].giftBalance * 100
            }else{
            	Toast.fail(res.data.message);
            }
        })

    },

    mounted() {
        let param = {
	        iccid: this.iccid,
	        mobile: localStorage.getItem('mobile'),
	    }
	    wxRequest("sysUser/account/querySysUserAccount", param, "post").then(res => {
	        if(res.data.code == 200){
	          	this.userAccount = res.data.data;  
	          	this.alreadySetUp = true;   
	        }
	    });
    },
    methods:{
        change(row,index){
            this.currentItem = index
            this.price = row.amount
            this.giftBalance = row.giftBalance * 100
        },
        toRecharge(){
            var data = {                
                iccid: this.iccid,
                amount: this.price*100,
                giftBalance: this.giftBalance,
                payPass: this.confirmPassword,
            }

            this.$store.state.showCheckstandSource = 'balanceRecharge';
            this.dataToPay = data;
            this.$store.state.showCheckstand = true;    
            this.cancelChangePassword();       
        },

        toRechargeDefined(){
    		var data = {                
                iccid: this.iccid,
                amount: this.definedPrice*100 ,
                giftBalance: this.giftBalance,
                payPass: this.confirmPassword,
            }

            this.$store.state.showCheckstandSource = 'balanceRecharge';

            this.dataToPay = data;
            this.$store.state.showCheckstand = true;
			this.price = this.definedPrice;
            this.definedPrice = '';
            // this.closePopup();

            this.cancelChangePassword();
        },
        //输入完密码后点击 【确定】 时
        sureToRecharge(){
        	if(this.checkPassword()){
        		if(this.type=="recharge"){
	        		this.toRecharge();
	        	}else if(this.type=="rechargeDefined"){
	        		// this.toRechargeDefined();
	        	}
        	}
        },

        btnActionRecharge(){
        	this.type = "recharge";
    		if(this.alreadySetUp){
                this.sureToRecharge();
            }else{
                this.showPasswordPanel = true;
            } 
    		        		
        },
         /***   修改密码     ***/
	    passwordOnfocus(){
	        this.passwordKeyboard = true;
	        this.confirmPasswordKeyboard = false;
	        this.passwordPanelTop = 30;
	    },
	    passwordOnDelete() {
	      this.password = this.password.slice(0, this.password.length - 1);
	    },

	    passwordOnInput(key) {
	        this.password = (this.password + key).slice(0, 6);
	    },


	    confirmPasswordOnfocus(){
	        this.passwordKeyboard = false;
	        this.confirmPasswordKeyboard = true;
	        this.passwordPanelTop = 30;
	    },
	    confirmPasswordOnDelete() {
	      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
	    },

	    confirmPasswordOnInput(key) {
	        this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
	    },


	    cancelChangePassword(){
	      this.password = '';
	      this.confirmPassword = '';
	      this.passwordPanelTop = 50;
	      this.showPasswordPanel = false;
	    },

	    checkPassword(){
        	if(this.alreadySetUp){
        		return true;
        	}
        	if(this.password.length < 6){
        		Toast.fail("请设置六位支付密码");
        		return false;
        	}

        	if(this.password != this.confirmPassword){
        		Toast.fail("两次输入的密码不一致");
        		return false;
        	}
        	return true;
        },
	    

	    /***   修改密码  end   ***/
    }
}
</script>
<style lang="less" scoped>
.page{
    width:calc(100% - 28px);
    padding:0 14px;
    min-height:calc(100% - 14px - 30px);
    padding-top: 14px;
    background: #F6F9FF;
    padding-bottom: 30px;
    .top{
        height:134px;
        text-align: center;
        background: url('~@/assets/she/21_1.png') no-repeat center;
        background-size:100% 100%;
        .price{
            font-family: HarmonyOS_Sans_SC_Bold;
            font-size: 22px;
            color: #FFEFE1;
            line-height: 30px;
            padding-top:22px;
        }
        .name{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #FFEFE1;
            line-height: 20px;
            opacity: .5;
        }
        .iccid{
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #FFEFE1;
            line-height: 20px;
            opacity: .5;
            padding-top:20px ;
        }
    }
    .title{
        margin-top:22px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 18px;
        color: #28292D;
        line-height: 25px;
        margin-bottom: 12px;
    }
    .v-h5-price{
        display: flex;
        align-items: center;
        margin-top:30px;
        flex-wrap: wrap;
        .v-item{
            width:30%;
            background:#fff;
            height: 95px;
            box-shadow: 0px 0px 8px 0px #D3E0FA;
            border: 1px solid #fff;
            text-align: center;
            border-radius: 10px;
            position: relative;
            margin-left: 15px;
            margin-bottom:30px;
            &:nth-child(3n+1){
                margin-left: 0;
            }
            .item-price{
                color:#F35631;
                font-size: 28px;
                font-family: HarmonyOS_Sans_SC_Bold;
                padding-top:24px;
                span{
                    font-size: 14px;
                    font-weight: 400;
                    font-family: PingFangSC, PingFang SC;
                    line-height: 20px;
                }
            }
            .sj-price{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 11px;
                color: #908B85;
                line-height: 16px;
                padding-top:8px;
            }
            .tj{
                position: absolute;
                width: 86px;
                height: 26px;
                background: linear-gradient( 270deg, #98BFF7 0%, #4980E9 100%);
                border-radius: 15px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;    
                color: #FFFFFF;
                line-height: 26px;
                top:-13px;
                left:0;
                right: 0;
                margin: 0 auto;
            }
        }
        .package-item-action{
            border: 1px solid #4980E9;
            background: #F6F9FF;
        }
    }
    .btn{
        background: #4980E9;
        border-radius: 22px;
        line-height:44px;
        text-align: center;
        color:#fff;
    }
    .footer{
        margin-top:40px;
        background: #FFFFFF;
        border-radius: 10px;
        padding:8px 14px 14px; 
        .title{
            margin-top: 0;
            span{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                line-height: 20px;
            }
        }
        img{
            width:100%;
        }
    }
    .changePasswordPanel-balanceRecharge{
	  padding: 10px;

	  .icon-cross{
	  	position: absolute; 
	  	right: 10px;
	  	font-size: 16px;
	  }

	  p{
	    margin: 10px 16px 0 16px;
	    line-height: 30px;
	  }

	  .confirmChangePassword{
	    display:flex;
	    justify-content: flex-end;
	    margin-top: 20px;

	    .confirmChangePasswordBtn{
	    	width: 80px;
	      	margin: 0 15px;
	    }
	  }


	}
}
</style>